import type { ReactNode } from 'react';

/** Limite un titre à 3 lignes maximum (avec « … »), de façon fiable quel que soit le reste du CSS. */
export const clamp3 = { display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' } as const;

/** Un onglet de présentation: libellé, photo et contenu texte déjà mis en forme. */
export type ShowcaseEntry = { id: string; label: string; image: string; alt: string; content: ReactNode };
